<template>
    <div class="border rounded-4 p-16">
        <div class="flex justify-between">
            <div>
                <div class="flex items-center mb-16">
                    <p class="mr-16 font-semibold text-body">{{ job.job_title }}</p>
                    <badge
                        :display="statusColor"
                        :content="job.status"
                    />
                </div>
                <div class="flex">
                    <div class="mr-48">
                        <label class="text-body-sm font-semibold">{{ $t('general.location') }}</label>
                        <p class="text-body-sm">{{ job.job_location.city }}</p>
                    </div>
                    <div class="mr-48">
                        <label class="text-body-sm font-semibold">{{ $t('general.type') }}</label>
                        <p class="text-body-sm">{{ job.job_type.toString() }}</p>
                    </div>
                    <div class="mr-48">
                        <label class="text-body-sm font-semibold">{{ $t('general.clicks') }}</label>
                        <p class="text-body-sm">{{ job.clicks }}</p>
                    </div>
                    <div class="mr-48">
                        <label class="text-body-sm font-semibold">{{ $t('general.applications.title') }}</label>
                        <p class="text-body-sm">{{ job.applications }}</p>
                    </div>
                </div>
            </div>
            <div class="flex flex-col justify-around">
                <SimpleButton
                    class="mb-12 w-full"
                    look="primary"
                    small
                    @click="boostVacancy"
                >
                    {{ $t('general.boost_vacancy') }}
                </SimpleButton>
                <SimpleButton
                    class="w-full"
                    small
                    @click="viewDetails"
                >
                    {{ $t('multi-posting.jobboards.vacancies.view') }}
                </SimpleButton>
            </div>
        </div>
    </div>
</template>

<script>

import Job from "../../models/Job";
import SimpleButton from "../ui/SimpleButton.vue";
import * as JobService from "../../services/JobService";
import _ from "lodash";
import {normalizeJson} from "../../../shared/helpers";
import Badge from "../ui/Badge.vue";
import {mapState, mapStores} from "pinia";
import {useMainStore} from "../../state/store";
import {useMultiPostingStore} from "../../state/modules/multiPosting";
import {useRepo} from "pinia-orm";

export default {
    name: 'JobBoardVacancyListItem',
    components: {Badge, SimpleButton},
    props: {
        product: {type: Object, required: true},
        job: {type: [Job, Object], required: true},
    },
    data() {
        return {
            selectedJob: null,
        }
    },
    computed: {
        ...mapStores(useMainStore, useMultiPostingStore),
        ...mapState(useMainStore, ['currentCompany', 'selectedLocale']),
        ...mapState(useMultiPostingStore, ['form']),
        locale() {
            return this.selectedLocale;
        },
        statusColor() {
            switch (this.job.status) {
                case 'online':
                    return 'success';
                case 'in progress':
                    return 'info';
                default:
                    return 'danger';
            }
        },
        publicationLanguages() {
            return this.currentCompany
                .jobsite
                .active_languages
                .map(lang => ({
                    value: lang,
                    label: _.capitalize(this.$t('languages.' + lang + '.adjective').toString())
                }));
        },
        status() {
            if (this.job.draft_mode) {
                return this.$t('campaigns.statuses.draft');
            }
            return this.$t(`multi-posting.campaigns.status.${this.job.status.replace(' ', '_')}`) || this.job.status
        },
    },
    methods: {
        initPublicationLanguage() {
            if (this.form.publicationLanguage) return

            if (this.publicationLanguages.includes(this.locale)) {
                this.form.publicationLanguage = this.locale;
            } else if (this.publicationLanguages.includes('en')) {
                this.form.publicationLanguage = 'en';
            } else {
                this.form.publicationLanguage = this.publicationLanguages[0].value;
            }
        },
        boostVacancy() {
            this.initPublicationLanguage()
            const job = useRepo(Job).find(this.job.job_id)
            const locale = this.locale
            this.multiPostingStore.applyJobData({job: job})
            this.multiPostingStore.applyLocaleData({job: job, locale: locale})
            this.multiPostingStore.setSelectedComponent('Campaigns');
            this.multiPostingStore.setCreatingCampaign(true);
        },
        viewDetails() {
            if (this.job.job_id) {
                this.$router.push({name: 'job', params: {id: this.job.job_id}});
            }
        }
    },
    beforeMount() {
        this.selectedJob = useRepo(Job).find(this.job);
    },
    mounted() {
        if (!this.selectedJob) {
            JobService.find(this.job.job_id)
                .then((results) => {
                    return useRepo(Job).save(normalizeJson(results));
                })
        }
    }
}
</script>
